var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-textarea',{attrs:{"id":"textarea-default","rows":"3","cols":"12"}})}
var staticRenderFns = []

export { render, staticRenderFns }